const TechStack = () => {
    return (
        <div className="w-full flex-col justify-start items-center gap-4 inline-flex mb-[60px]">
            <div className="h-11 text-center bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text text-[24px] lg:text-3xl font-extrabold font-['Open Sans']">
                Технологический стек
            </div>
            <div className="self-stretch justify-center items-start inline-flex">
                <div className="text-center text-[#58493b] text-[10px] lg:text-xl font-normal font-['Open Sans']">
                    Серверная часть, работающая на Java, обеспечивает высокую производительность и безопасность.<br />
                    Ключ-Астром благодаря возможности разворачиваться в виде отказоустойчивого кластера на основе NoSQL-базы <br className="hidden lg:block" /> данных Apache Cassandra, обеспечивает сохранность ваших данных и высокую скорость доступа к ним.
                </div>
            </div>
        </div>
    );
}

export default TechStack;
